import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

export function fetchMenuItems(orderTypeId, sourceId, divisionId) {
    return Vue.axios.get(`${$themeConfig.app.menuUrl}/menu-items`, {
        params: {
            order_type_id: orderTypeId,
            source_id: sourceId,
            division_id: divisionId,
            include: ['modifiers', 'parameters'],
        },
    })
}

export function fetchMenuCategories(divisionId, orderTypeId, sourceId) {
    return Vue.axios.get(`${$themeConfig.app.menuUrl}/categories`, {
        params: {
            division_id: divisionId,
            ...(orderTypeId && { order_type_id: orderTypeId }),
            ...(sourceId && { source_id: sourceId }),
            depth: 0,
        },
    })
}
